import { uploadTypeForBucket, uploadUserDocumentToS3Async } from "api/document";

/**
 * Upload a file to S3 via the an-api backend (no direct AWS access / credentials
 * in the browser). The backend selects the bucket from `type` and performs the
 * PutObject.
 *
 * Callers historically passed `bucket`; we map it to the backend `type` via
 * `uploadTypeForBucket`. The legacy aws-sdk `params` object is still honoured
 * for `ACL` and `ContentType`; explicit `acl` overrides it.
 *
 * @param {Object} options
 * @param {File} options.file - The file to upload
 * @param {string} options.key - Required: full S3 key
 * @param {string} [options.bucket] - Legacy bucket name; mapped to `type`
 * @param {import("api/document").UploadType} [options.type] - Preferred over `bucket`
 * @param {"public-read"|"private"|"authenticated-read"} [options.acl] - not allowed for MMS
 * @param {{ ACL?: string, ContentType?: string }} [options.params] - Legacy aws-sdk params
 * @returns {Promise<{ Bucket: string, Key: string, ETag?: string, Location?: string }>}
 */
export const uploadToS3 = async ({ file, key, bucket, type, acl, params }) => {
  if (!file || !key) {
    console.error("Both file and key are required");
    return;
  }

  const response = await uploadUserDocumentToS3Async({
    file,
    key,
    type: type || uploadTypeForBucket(bucket),
    contentType: params?.ContentType || file.type || "application/octet-stream",
    acl: acl || params?.ACL,
  });

  return response.data;
};
